import Swiper from "./swiper";

var serviceSlide = new Swiper(".service_slider", {
    // loop: true,
    // autoplay: {
    //     delay: 4500,
    //     disableOnInteraction: true
    // }
    on: {
        transitionEnd: function() {
            // console.log(this.activeIndex);
        }
    }
});
const slideThumbsLi = document.querySelectorAll(".slide_thumbs li");

slideThumbsLi.forEach((target, index) => {
    target.addEventListener("click", e => {
        console.log(index);
        for (var i = 0; i < slideThumbsLi.length; i++) {
            slideThumbsLi[i].classList.remove("active");
        }
        e.currentTarget.classList.add("active");
        serviceSlide.slideTo(index);
    });
});
